import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  settingsData: null,
  subscriptionPlan: null,
  isLoading: false,
  error: null,
  success: false,
};

export const settingsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase("getSettingsRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("getSettingsSuccess", (state, action) => {
      state.isLoading = false;
      state.settingsData = action.payload;
    })
    .addCase("getSettingsFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase("updateSettingsRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("updateSettingsSuccess", (state, action) => {
      state.isLoading = false;
      state.settingsData = action.payload;
      state.success = true;
    })
    .addCase("updateSettingsFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase("updateReceiptSettingsRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("updateReceiptSettingsSuccess", (state, action) => {
      state.isLoading = false;
      state.settingsData = action.payload;
      state.success = true;
    })
    .addCase("updateReceiptSettingsFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase("updateSubscriptionPlanRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("updateSubscriptionPlanSuccess", (state, action) => {
      state.isLoading = false;
      state.settingsData = action.payload;
      state.success = true;
    })
    .addCase("updateSubscriptionPlanFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase("activateSubscriptionRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("activateSubscriptionSuccess", (state, action) => {
      state.isLoading = false;
      state.settingsData = action.payload;
      state.success = true;
    })
    .addCase("activateSubscriptionFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase("deactivateSubscriptionRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("deactivateSubscriptionSuccess", (state, action) => {
      state.isLoading = false;
      state.settingsData = action.payload;
      state.success = true;
    })
    .addCase("deactivateSubscriptionFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    // get subscription Plan
    .addCase("getSubscriptionPlanRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("getSubscriptionPlanSuccess", (state, action) => {
      state.isLoading = false;
      state.subscriptionPlan = action.payload;
    })
    .addCase("getSubscriptionPlanFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase("clearErrors", (state) => {
      state.error = null;
    })
    .addCase("clearSuccess", (state) => {
      state.success = false;
    });
});